import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RedeemActivityContent from "modules/RedeemActivity";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const RedeemActivityPage: React.FC = () => {
  setTitle("Redeem Activity");
  return (
    <Auth>
      <Layout>
        <RedeemActivityContent />
      </Layout>
    </Auth>
  );
};

export default RedeemActivityPage;
